export enum SkypeNotificationType {
    None,
    ToastAndSound,
    ToastOnly,
    Migrated,
}

export default SkypeNotificationType;
